import styled from "styled-components";

export const CheckboxColorWrapper = styled.div`
    div[class*="CometAdminFormFieldContainer-inputContainer"] {
        margin-left: -9px;
    }
`;

export const CheckBoxSectionContainer = styled.div`
    div[class*="CometAdminFormFieldContainer-horizontal"] {
        align-items: flex-start;
    }

    .CometAdminFormFieldContainer-inputContainer {
        display: flex;
        flex-direction: column;
    }
`;
